import React, { useCallback, useState } from 'react';
import { WidthFeature } from '@/editor/panel/views/brush-panel/components/width/width';

const SelectWidth: React.FC<{
    defaultVal: number;
    dataSource: any;
    onComplete?: Function;
    isStroke?: boolean;
    maxValue?: number;
    minValue?: number;
}> = React.memo(({ isStroke = false, defaultVal, dataSource, onComplete, maxValue, minValue }) => {
    const [width, setWidth] = useState(defaultVal);

    const onWidthAfterChange = useCallback((trackCode, data) => {
        setWidth(data);
        dataSource.width = data;
        onComplete?.();
    }, []);

    const onWidthChange = useCallback((data) => {
        setWidth(data);
        dataSource.width = data;
    }, []);

    return (
        <WidthFeature
            isStroke={isStroke}
            width={width}
            onAfterChange={onWidthAfterChange}
            onChange={onWidthChange}
            style={{ paddingTop: 12 }}
            maxValue={maxValue}
            minValue={minValue}
        />
    );
});

export default SelectWidth;
